import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
// Components
import Select from "../../../components/form/Select";
// Store and Services
import { saveAccount, getAccountUrls } from "../../../services/accountService";

export default function AddAccount() {
  const navigate = useNavigate();
  const [urls, setUrls] = useState([]);
  
  const STATUS_OPTIONS = [
    { value: 0, label: "Inactive" },
    { value: 1, label: "Active" }
  ];

  useEffect(() => {

    getAccountUrls().then((res) => {
      setUrls(res.data.data);
    });

  }, []);

  const initialValues = {
      url: "",
      skin: "",
      account: "",
      password: "",
      label: "",
      active_for_telegram: 0,
      active_for_scrapper: 0,
      active_for_balance: 0,
    };
    const validationSchema = Yup.object({
      url: Yup.string()
        .required("Please select the url"),
      skin: Yup.string(),
      account: Yup.string()
        .required("Please enter the account"),
      password: Yup.string()
        .required("Please enter the password"),
      label: Yup.string()
        .required("Please enter the label"),
      active_for_telegram: Yup.boolean(),
      active_for_scrapper: Yup.boolean(),
      active_for_balance: Yup.boolean(),
      
    });
    

    // Form submission handler
    const onSubmit = async (values, { setSubmitting, resetForm }) => {
      console.log('form: ', values);
      
      await saveAccount(values).then((res) => {
        if (res.data.status === "success") {
          toast.success(res.data.message);
          // Clear the form
          resetForm();
        }
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          // Validation errors
          const validationErrors = error.response.data.errors;
          for (const [field, messages] of Object.entries(validationErrors)) {
            // Show error messages for each field
            messages.forEach(message => toast.error(`${message}`));
          }
        } else {
          // Other errors
          toast.error('An error occurred. Please try again.');
        }
       
      });

      setSubmitting(false); // Reset isSubmitting to false after submission
    };
    

  return (
    <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
    {({ isSubmitting }) => (
    <Form>
    
    <h1 className="font-bold text-xl">Add Account</h1>
    
    <hr className="border-black border-2 mt-2" />
    
    <div className="grid grid-cols-2 gap-4 mt-4">
      
      <div className="col-span-1">
        <label htmlFor="website" className="form-label required">URL</label>
        <Select name="url" options={urls}/>
        <ErrorMessage name="website" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="skin" className="form-label">Skin</label>
        <Field
          type="text"
          name="skin"
          id="skin"
          className="form-control"
        />
        <ErrorMessage name="skin" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="account" className="form-label required">Account</label>
        <Field
          type="text"
          name="account"
          id="account"
          className="form-control"
        />
        <ErrorMessage name="account" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="password" className="form-label required">Password</label>
        <Field
          type="text"
          name="password"
          id="password"
          className="form-control"
        />
        <ErrorMessage name="password" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="label" className="form-label required">Label</label>
        <Field
          type="text"
          name="label"
          id="label"
          className="form-control"
        />
        <ErrorMessage name="label" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="active_for_telegram" className="form-label">Pending Wagers</label>
        <Select
          name="active_for_telegram"
          options={STATUS_OPTIONS}
        />
        <ErrorMessage name="active_for_telegram" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="active_for_scrapper" className="form-label">Daily Figures</label>
        <Select
          name="active_for_scrapper"
          options={STATUS_OPTIONS}
        />
        <ErrorMessage name="active_for_scrapper" component="div" className="form-error" />
      </div>

      <div className="col-span-1">
        <label htmlFor="active_for_balance" className="form-label">Balance</label>
        <Select
          name="active_for_balance"
          options={STATUS_OPTIONS}
        />
        <ErrorMessage name="active_for_balance" component="div" className="form-error" />
      </div>

    </div>
  
    {/* Submit Button */}
    <div className="w-full flex justify-end mt-4">
        <button
        type="submit"
        className="btn-primary"
        disabled={isSubmitting}
        >
        {isSubmitting ? "Saving..." : "Add Account"}
        </button>
    </div>

  </Form>
  
    )}

</Formik>
  );
}
